module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-vert-de-gris-019-1200x2490.fe1db787.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-vert-de-gris-019-1200x2490.jpg
// module id = 1102
// module chunks = 37